"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    alert: 'Notiser' || 'alert',
    raiseAlert: 'Skapa notis' || 'raiseAlert',
    closeAlert: 'Stäng notis' || 'closeAlert',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    title: 'Rubrik' || 'title',
    description: 'Beskrivning' || 'description',
    link: 'Länk' || 'link',
    color: 'Färg' || 'color',
    colors: {
        danger: 'Farligt' || 'danger',
        warning: 'Varning' || 'warning',
        success: 'Framgång' || 'success',
        info: 'Info' || 'info',
        primary: 'Primär' || 'primary',
        secondary: 'Sekundär' || 'secondary',
    },
    isClosed: 'Klar?' || 'isClosed',
    alertContext: 'Context' || 'alertContext',
    organization: 'Mottagande organization' || 'organization',
};
